import * as eudo from './EudoDeclare'

export { eudo }
